const translations = {
  nl: {
    administratie: "Administratie",
    ordersGoedkeuren: "Orders goedkeuren",
    teelt: "Teelt",
    transport: "Transport",
    dossierTeelt: "Dossier Teelt",
    dossierTransport: "Dossier Transport",
    klantgegevens: "Klantgegevens",
    orderinformatie: "Orderinformatie",
    goedgekeurdeOrders: "Goedgekeurde orders",
    rollen: "Rollen",
    facturen: "Facturen",
    factuur: "Factuur",
    voorwaardenAccepteren: "Voorwaarden accepteren",
    betreftOrder: "Betreft order:", 
    algemeneVoorwaarden: "Algemene voorwaarden", 
    voorwaardenAccepteren: "Ik heb de voorwaarden gelezen en ga daarmee akkoord", 
    goedkeuren: "Goedkeuren", 
    annuleren: "Annuleren",
    vor: "VOR",
    grw: "GRW",
    globalGap: "GlobalGap",
    partijInformatie: "Partij informatie",
    algemeen: "Algemeen",
    naam: "Naam",
    adres: "Adres",
    postcode: "Postcode",
    plaats: "Plaats",
    telefoon: "Telefoon",
    ordernummer: "Ordernummer",
    detail: "Detail",
    download: "Download",
    orderstatus: "Orderstatus",
    verzendnaam: "Verzendnaam",
    orderdatum: "Orderdatum",
    leverdatum: "Leverdatum",
    orderlijst: "Orderlijst",
    plantPartijen: "Plant partijen",
    teeltlijnen: "Teeltlijnen",
    verzendAdres: "Verzendadres (indien geen verzendadres aanwezig, is deze gelijk aan het debiteuradres)",
    contactpersonen: "Contactpersonen",
    email: "Email",
    orderGoedkeuren: "Order inzien en goedkeuren",
    gebruikersKlantenportaal: "Gebruikers klantenportaal",
    verzendnr: "Verzendnr.",
    bedrijf: "Bedrijf",
    laaddatumTijd: "Laaddatum en tijd",
    leverdatumTijd: "Leverdatum en tijd",
    ritnummer: "Ritnummer",
    afgeleverd: "Afgeleverd",
    afleverdatum: "Afleverdatum",
    tijd: "Tijd",
    expediteurnaam: "Expediteurnaam",
    afleverbon: "Afleverbon",
    plantenpaspoort: "Plantenpaspoort",
    transportMelden: "Transport melden",
    zekerWeten: "Weet u het zeker?",
    terug: "Terug",
    uitloggen: "Uitloggen",
    bevestigen: "Bevestigen",
    transportBevestigen: "Transport bevestigen",
    aantalFotos: "Aantal fotos",
    datum: "Datum",
    zoekPlaceholderOrderinformatie: "Zoek op Ordernummer, datum...",
    zoekPlaceholderFacturen: "Zoek op datum, factuur, order...",
    zoekPlaceholderTransport: "Zoek op transport, datum...",
    omschrijving: "Omschrijving",
    vervaldatum: "Vervaldatum",
    eindbon: "Eindbon",
    status: "Status",
    exclBtw: "Ex. BTW",
    inclBtw: "Incl. BTW",
    actie: "Actie",
    soort: "Soort",
    titel: "Titel",
    orderNietCompleetForecast: "De order is wellicht nog niet compleet genoeg om de PDF te genereren. U bent opgenomen in onze forecast.",

    pagination: { 
      previous: "Vorige", 
      next: "Volgende", 
      page: "Pagina", 
      of: "van", 
    },

    login: {
      title: "Inloggen",
      email: "Email",
      password: "Wachtwoord",
      button: "Inloggen",
      forgotPassword: "Wachtwoord vergeten?",
    },

    forgotPasswordPage: {
      title: "Wachtwoord vergeten",
      intro:
        "Vul hieronder uw e-mailadres in. Als dit bij ons bekend is, ontvangt u een e-mail met een link om uw wachtwoord opnieuw in te stellen.",
      boxTitle: "Wachtwoord vergeten",
      boxText:
        "Voer het e-mailadres in dat u gebruikt om in te loggen op het portaal. Als dit wordt herkend, ontvangt u een e-mail met instructies om uw wachtwoord opnieuw in te stellen.",
      button: "Verstuur reset e-mail",
      backToLogin: "Terug naar login",
    },

    resetPasswordPage: {
      title: "Nieuw wachtwoord instellen",
      intro:
        "Vul hieronder uw nieuwe wachtwoord in om weer toegang te krijgen tot het portaal.",
      boxTitle: "Wachtwoord resetten",
      boxText: "Voer hieronder uw nieuwe wachtwoord in.",
      newPassword: "Nieuw wachtwoord",
      repeatPassword: "Herhaal wachtwoord",
      button: "Wachtwoord opslaan",
      invalidLink: "De resetlink is ongeldig.",
      passwordsDontMatch: "De wachtwoorden komen niet overeen.",
    },

    signupPage: {
      title: "Wachtwoord instellen",
      intro:
        "Voer hier uw e-mailadres in dat u gebruikt om in te loggen op het Klantenportaal. Als dit wordt herkend, kunt u uw nieuwe wachtwoord invoeren.",
      boxTitle: "Wachtwoord instellen",
      boxText:
        "Voer het e-mailadres in dat u gebruikt om in te loggen op het portaal. Als dit wordt herkend, kunt u uw nieuwe wachtwoord instellen.",
      passwordLabel: "Wachtwoord voor Klantenportaal",
      checkEmail: "Check Email",
      submit: "Instellen",
    },
    evaluationStatusHeader: "Evaluatie status",
    evaluationStatusPending: "Nog niet gestart",
    evaluationStatusInProgress: "Bezig",
    evaluationStatusCompleted: "Afgerond",
    evaluationStatusCancelled: "Geannuleerd",
    evaluationStatusUnknown: "Onbekend",
    evaluationActionStart: "Start evaluatie",
    evaluationActionContinue: "Verder invullen",
    evaluationActionCompleted: "Afgerond",
    evaluationActionCancelled: "Geannuleerd",
    evaluationsPageTitle: "Evaluaties",
    evaluationSearchPlaceholder: "Zoek op ordernummer, klant, status of datum...",
    evaluationNoReleasedOrders: "Geen orders beschikbaar waarvoor een evaluatie is vrijgegeven.",
    
    evaluationLoadingTitle: "Evaluatie laden...",
    evaluationUnavailableTitle: "Evaluatie niet beschikbaar",
    evaluationCompletedTitle: "Evaluatie afgerond",
    evaluationCompletedText: "Deze evaluatie is al volledig ingevuld en kan niet meer worden aangepast.",
    evaluationThankYouTitle: "Bedankt voor uw evaluatie!",
    evaluationThankYouText: "Uw feedback is succesvol verzonden.",
    evaluationTitle: "Order Evaluatie",
    evaluationWelcomeTitle: "Welkom bij de evaluatie",
    evaluationIntroOrderText: "Dit is de evaluatie van",
    evaluationIntroVarietyCountText: "Deze order bevat",
    evaluationVarieties: "rassen",
    evaluationStartButton: "Start evaluatie",
    evaluationSavingButton: "Opslaan...",
    evaluationCompletingButton: "Afronden...",
    evaluationCompleteButton: "Afronden",
    
    evaluationVariety: "Ras",
    evaluationVarietyInfoTitle: "Ras informatie",
    evaluationVarietyLabel: "Ras",
    evaluationQuantityLabel: "Hoeveelheid",
    evaluationPlantExpectationsTitle: "Plant verwachtingen",
    evaluationQuestionUniformity: "Uniformiteit plant",
    evaluationQuestionTrussDevelopment: "Tros ontwikkeling",
    evaluationTrussDevelopmentExplanationLabel: "Toelichting tros ontwikkeling",
    evaluationQuestionDaysToFlowering: "Aantal dagen na levering bloei",
    evaluationQuestionLeavesBetweenTrusses: "Aantal bladeren tussen tros 1 en 2",
    evaluationQuestionOtherRemarks: "Overige opmerkingen",
    
    evaluationDiseasesPestsTitle: "Ziektes / plagen",
    evaluationQuestionWhitefly: "Witte vlieg",
    evaluationQuestionCaterpillarTuta: "Rups / tuta",
    evaluationQuestionThrips: "Trips",
    evaluationQuestionAphids: "Luis",
    evaluationQuestionOther: "Anders",
    evaluationOtherDiseaseRemarkLabel: "Opmerking bij anders",
    evaluationOtherDiseaseRemarkPlaceholder: "Beschrijf welke ziekte of plaag is waargenomen...",
    
    evaluationGeneralDeliveryQuestionsTitle: "Algemene vragen over de levering",
    evaluationVarietyQuestionsCompletedText: "De ras-specifieke vragen zijn ingevuld.",
    evaluationGeneralDeliveryQuestionsTextBeforeOrder: "De volgende vragen gaan over de volledige levering van",
    evaluationGeneralDeliveryQuestionsTextAfterOrder: "en gelden dus niet per ras, maar voor de order als geheel.",
    evaluationDeliveryTitle: "Levering",
    evaluationQuestionStakePlacement: "Stok(-ken) op juiste plek gestoken",
    evaluationQuestionElasticClipHeight: "Stiek/ clip op juiste hoogte aangebracht",
    evaluationQuestionSortedCorrectly: "Goed gesorteerd",
    evaluationQuestionTrolleysClean: "Karren schoon bij levering",
    evaluationQuestionDeliveredOnTime: "Leveringen op tijd",
    evaluationQuestionTrialsDeviationsClear: "Proeven en afwijkingen duidelijk aangegeven",
    evaluationQuestionPlantsDamaged: "Planten beschadigd",
    
    evaluationCommunicationTitle: "Communicatie",
    evaluationDepartmentHeader: "Afdeling",
    evaluationDepartmentSales: "Verkoop",
    evaluationDepartmentCultivationManager: "Teler",
    evaluationDepartmentTransport: "Transport afdeling",
    
    evaluationGeneralImpressionTitle: "Algemene indruk",
    evaluationGeneralImpressionLabel: "Algemene indruk (1 t/m 10)",
    evaluationGeneralImpressionValidation: "Vul een cijfer in tussen 1 en 10 om door te gaan.",
    
    evaluationOptionEqual: "Gelijk",
    evaluationOptionUnequal: "Ongelijk",
    evaluationOptionGood: "Goed",
    evaluationOptionNotGood: "Niet goed",
    evaluationOptionModerate: "Matig",
    evaluationOptionBad: "Slecht",
    evaluationOptionSufficient: "Voldoende",
    evaluationOptionInsufficient: "Onvoldoende",
    evaluationOptionBonken: "Bonken",
    evaluationOptionSplitTruss: "Splijttros",
    evaluationOptionLeafOnTruss: "Blaadje op tros",
    evaluationOptionNoneNotApplicable: "Geen / niet van toepassing",
    evaluationOptionHeadless: "Koploos",
    evaluationOptionCurlyHead: "Kroeskop",
    evaluationOptionShootCountDeviation: "Aantal scheuten wijkt af",
    evaluationOptionPotTooDry: "Pot te droog",
    
    evaluationSelectPlaceholder: "Maak een keuze",
    evaluationErrorAlreadyCompleted: "Deze evaluatie is afgerond en kan niet meer worden aangepast.",
    evaluationErrorSaveFailed: "Opslaan van de evaluatie is mislukt.",
    evaluationErrorCompleteFailed: "Afronden van de evaluatie is mislukt.",
    evaluationErrorNoVarieties: "Er zijn geen rassen gevonden voor deze order.",
    evaluationErrorNotAllowed: "Voor deze order is nog geen evaluatie toegestaan.",
    evaluationErrorLoadFailed: "Evaluatie kon niet worden geladen.",
    
    order: "Order",
    pieces: "stuks",
    yes: "Ja",
    no: "Nee",
    previous: "Vorige",
    next: "Volgende",
    of: "van",
    page: "Pagina",
    notAvailable: "N.v.t.",
    noOrdersAvailable: "Geen orders beschikbaar."
  },

  en: {
    administratie: "Administration",
    ordersGoedkeuren: "Approve orders",
    teelt: "Cultivation",
    transport: "Transport",
    dossierTeelt: "Dossier Cultivation",
    dossierTransport: "Dossier Transport",
    klantgegevens: "Customer information",
    orderinformatie: "Order information",
    goedgekeurdeOrders: "Approved orders",
    rollen: "Roles",
    facturen: "Invoices",
    factuur: "Invoice",
    voorwaardenAccepteren: "Accept conditions",
    betreftOrder: "Regarding order:",
    algemeneVoorwaarden: "Terms and conditions",
    voorwaardenAccepteren: "I have read and agree to the terms and conditions",
    goedkeuren: "Approve",
    annuleren: "Cancel",
    vor: "VOR",
    grw: "GRW",
    globalGap: "GlobalGap",
    partijInformatie: "Batch information",
    algemeen: "General",
    naam: "Name",
    adres: "Address",
    postcode: "Zipcode",
    plaats: "City",
    telefoon: "Phone",
    ordernummer: "Order number",
    detail: "Details",
    download: "Download",
    orderstatus: "Order status",
    verzendnaam: "Shipping name",
    orderdatum: "Order date",
    leverdatum: "Delivery date",
    orderlijst: "Order list",
    plantPartijen: "Plant batches",
    teeltlijnen: "Cultivation lines",
    verzendAdres: "Shipping address (if no shipping address is available, this is the same as the debtor address)",
    contactpersonen: "Contacts",
    email: "Email",
    orderGoedkeuren: "View and approve order",
    gebruikersKlantenportaal: "Users customer portal",
    verzendnr: "Shipping no.",
    bedrijf: "Company",
    laaddatumTijd: "Loading date & time",
    leverdatumTijd: "Delivery date & time",
    ritnummer: "Cargo number",
    afgeleverd: "Delivered",
    afleverdatum: "Delivery date",
    tijd: "Time",
    expediteurnaam: "Carrier name",
    afleverbon: "Delivery note",
    plantenpaspoort: "Plant passport",
    transportMelden: "Report delivery",
    zekerWeten: "Are you sure?",
    terug: "Cancel",
    uitloggen: "Log out",
    bevestigen: "Confirm",
    transportBevestigen: "Confirm delivery",
    aantalFotos: "Amount of pictures",
    datum: "Date",
    zoekPlaceholderOrderinformatie: "Search by order number, date...",
    zoekPlaceholderFacturen: "Search by date, invoice, order...",
    zoekPlaceholderTransport: "Search by transport, date...",
    omschrijving: "Description",
    vervaldatum: "Due date",
    eindbon: "Final receipt",
    status: "Status",
    exclBtw: "Excl. VAT",
    inclBtw: "Incl. VAT",
    actie: "Action",
    soort: "Document type",
    titel: "Title",
    orderNietCompleetForecast: "The order may not yet be complete enough to generate the PDF. You have been included in our forecast.",

    pagination: {
      previous: "Previous",
      next: "Next",
      page: "Page",
      of: "of",
    },

    login: {
      title: "Login",
      email: "Email",
      password: "Password",
      button: "Login",
      forgotPassword: "Forgot password?",
    },

    forgotPasswordPage: {
      title: "Forgot password",
      intro:
        "Enter your e-mail address below. If it is known to us, you will receive an e-mail with a link to reset your password.",
      boxTitle: "Forgot password",
      boxText:
        "Enter the e-mail address that you use to login to the portal. If it is recognized, you will receive an e-mail with reset instructions.",
      button: "Send reset e-mail",
      backToLogin: "Back to login",
    },

    resetPasswordPage: {
      title: "Set new password",
      intro:
        "Enter your new password below to regain access to the portal.",
      boxTitle: "Reset password",
      boxText: "Enter your new password below.",
      newPassword: "New password",
      repeatPassword: "Repeat password",
      button: "Save password",
      invalidLink: "The reset link is invalid.",
      passwordsDontMatch: "The passwords do not match.",
    },

    signupPage: {
      title: "Set password",
      intro:
        "Enter the e-mail address that you use to login to the customer portal. If it is recognized, you can set your new password.",
      boxTitle: "Set password",
      boxText:
        "Enter the e-mail address that you use to login to the portal. If it is recognized, you can set your new password.",
      passwordLabel: "Password for customer portal",
      checkEmail: "Check Email",
      submit: "Set password",
    },
    evaluationStatusHeader: "Evaluation status",
evaluationStatusPending: "Not started",
evaluationStatusInProgress: "In progress",
evaluationStatusCompleted: "Completed",
evaluationStatusCancelled: "Cancelled",
evaluationStatusUnknown: "Unknown",

evaluationActionStart: "Start evaluation",
evaluationActionContinue: "Continue filling in",
evaluationActionCompleted: "Completed",
evaluationActionCancelled: "Cancelled",

evaluationsPageTitle: "Evaluations",
evaluationSearchPlaceholder: "Search by order number, customer, status or date...",
evaluationNoReleasedOrders: "No orders available for which an evaluation has been released.",

evaluationLoadingTitle: "Loading evaluation...",
evaluationUnavailableTitle: "Evaluation not available",
evaluationCompletedTitle: "Evaluation completed",
evaluationCompletedText: "This evaluation has already been completed and can no longer be changed.",
evaluationThankYouTitle: "Thank you for your evaluation!",
evaluationThankYouText: "Your feedback has been submitted successfully.",

evaluationTitle: "Order evaluation",
evaluationWelcomeTitle: "Welcome to the evaluation",
evaluationIntroOrderText: "This is the evaluation for",
evaluationIntroVarietyCountText: "This order contains",
evaluationVarieties: "varieties",

evaluationStartButton: "Start evaluation",
evaluationSavingButton: "Saving...",
evaluationCompletingButton: "Completing...",
evaluationCompleteButton: "Complete",

evaluationVariety: "Variety",
evaluationVarietyInfoTitle: "Variety information",
evaluationVarietyLabel: "Variety",
evaluationQuantityLabel: "Quantity",

evaluationPlantExpectationsTitle: "Plant expectations",
evaluationQuestionUniformity: "Plant uniformity",
evaluationQuestionTrussDevelopment: "Cluster development",
evaluationTrussDevelopmentExplanationLabel: "Explanation of cluster development",
evaluationQuestionDaysToFlowering: "Number of days after delivery until flowering",
evaluationQuestionLeavesBetweenTrusses: "Number of leaves between cluster 1 and 2",
evaluationQuestionOtherRemarks: "Other comments",

evaluationDiseasesPestsTitle: "Diseases / pests",
evaluationQuestionWhitefly: "Whitefly",
evaluationQuestionCaterpillarTuta: "Caterpillar / Tuta",
evaluationQuestionThrips: "Thrips",
evaluationQuestionAphids: "Aphid",
evaluationQuestionOther: "Otherwise",
evaluationOtherDiseaseRemarkLabel: "Note regarding otherwise",
evaluationOtherDiseaseRemarkPlaceholder: "Describe which disease or pest was observed...",

evaluationGeneralDeliveryQuestionsTitle: "General questions about the delivery",
evaluationVarietyQuestionsCompletedText: "The variety-specific questions have been completed.",
evaluationGeneralDeliveryQuestionsTextBeforeOrder: "The following questions concern the entire delivery for",
evaluationGeneralDeliveryQuestionsTextAfterOrder: "and therefore do not apply per variety, but to the order as a whole.",

evaluationDeliveryTitle: "Delivery",
evaluationQuestionStakePlacement: "Stake(s) placed in the correct position",
evaluationQuestionElasticClipHeight: "Elastic / clip attached at the correct height",
evaluationQuestionSortedCorrectly: "Correctly sorted",
evaluationQuestionTrolleysClean: "Trolleys clean upon delivery",
evaluationQuestionDeliveredOnTime: "Deliveries on time",
evaluationQuestionTrialsDeviationsClear: "Trials and deviations clearly indicated",
evaluationQuestionPlantsDamaged: "Plants damaged",

evaluationCommunicationTitle: "Communication",
evaluationDepartmentHeader: "Department",
evaluationDepartmentSales: "Sales",
evaluationDepartmentCultivationManager: "Grower",
evaluationDepartmentTransport: "Transport department",

evaluationGeneralImpressionTitle: "Overall impression",
evaluationGeneralImpressionLabel: "Overall impression (1 to 10)",
evaluationGeneralImpressionValidation: "Enter a score between 1 and 10 to continue.",

evaluationOptionEqual: "Equal",
evaluationOptionUnequal: "Unequal",
evaluationOptionGood: "Good",
evaluationOptionNotGood: "Not good",
evaluationOptionModerate: "Moderate",
evaluationOptionBad: "Bad",
evaluationOptionSufficient: "Sufficient",
evaluationOptionInsufficient: "Insufficient",

evaluationOptionBonken: "Lumpy truss formation",
evaluationOptionSplitTruss: "Split truss",
evaluationOptionLeafOnTruss: "Leaf on truss",
evaluationOptionNoneNotApplicable: "None / not applicable",
evaluationOptionHeadless: "Headless",
evaluationOptionCurlyHead: "Curly head",
evaluationOptionShootCountDeviation: "Number of shoots differs",
evaluationOptionPotTooDry: "Pot too dry",

evaluationSelectPlaceholder: "Select an option",

evaluationErrorAlreadyCompleted: "This evaluation has been completed and can no longer be changed.",
evaluationErrorSaveFailed: "Saving the evaluation failed.",
evaluationErrorCompleteFailed: "Completing the evaluation failed.",
evaluationErrorNoVarieties: "No varieties were found for this order.",
evaluationErrorNotAllowed: "An evaluation is not yet allowed for this order.",
evaluationErrorLoadFailed: "The evaluation could not be loaded.",

order: "Order",
pieces: "pieces",
yes: "Yes",
no: "No",
previous: "Previous",
next: "Next",
of: "of",
page: "Page",
notAvailable: "N/A",
noOrdersAvailable: "No orders available.",

  },

  de: {
    administratie: "Verwaltung",
    ordersGoedkeuren: "Aufträge genehmigen",
    teelt: "Anbau",
    transport: "Transport",
    dossierTeelt: "Dossier Anbau",
    dossierTransport: "Dossier Transport",
    klantgegevens: "Kundendaten",
    orderinformatie: "Bestellinformationen",
    goedgekeurdeOrders: "Genehmigt aufträge",
    rollen: "Rollen",
    facturen: "Rechnungen",
    factuur: "Rechnung",
    voorwaardenAccepteren: "Bedingungen akzeptieren",
    betreftOrder: "Bezüglich Auftrag:",
    algemeneVoorwaarden: "Allgemeine Geschäftsbedingungen",
    voorwaardenAccepteren: "Ich habe die Bedingungen gelesen und stimme ihnen zu",
    goedkeuren: "Genehmigen",
    annuleren: "Stornieren",
    vor: "VOR",
    grw: "GRW",
    globalGap: "GlobalGap",
    partijInformatie: "Chargen information",
    algemeen: "General",
    naam: "Name",
    adres: "Adresse",
    postcode: "Postleitzahl",
    plaats: "Residenz",
    telefoon: "Telefon",
    ordernummer: "Bestellnummer",
    detail: "Details",
    download: "Herunterladen",
    orderstatus: "Bestellstatus",
    verzendnaam: "Versandname",
    orderdatum: "Bestelldatum",
    leverdatum: "Lieferdatum",
    orderlijst: "Bestellliste",
    plantPartijen: "Pflanz chargen",
    teeltlijnen: "Kultivierungslinien",
    verzendAdres: "Lieferadresse (wenn keine Lieferadresse verfügbar ist, entspricht diese der Postadresse)",
    contactpersonen: "Kontakte",
    email: "Email",
    orderGoedkeuren: "Bestellung ansehen und genehmigen",
    gebruikersKlantenportaal: "Benutzer Kundenportal",
    verzendnr: "Versandnr.",
    bedrijf: "Firm",
    laaddatumTijd: "Ladedatum und Zeit",
    leverdatumTijd: "Lieferdatum und Zeit",
    ritnummer: "Fahrtnummer",
    afgeleverd: "Geliefert",
    afleverdatum: "Lieferdatum",
    tijd: "Uhrzeit",
    expediteurnaam: "Spediteur",
    afleverbon: "Lieferschein",
    plantenpaspoort: "Pflanzenpass",
    transportMelden: "Transport liefern",
    zekerWeten: "Bist du sicher?",
    terug: "Zurück",
    uitloggen: "Ausloggen",
    bevestigen: "Bestätigen",
    transportBevestigen: "Transport bestätigen",
    aantalFotos: "Anzahl der Fotos",
    datum: "Datum",
    zoekPlaceholderOrderinformatie: "Nach Bestellnummer, Datum suchen...",
    zoekPlaceholderFacturen: "Nach Datum, Rechnung, Bestellung suchen...",
    zoekPlaceholderTransport: "Suche nach Transport, Datum...",
    omschrijving: "Beschreibung",
    vervaldatum: "Fälligkeitsdatum",
    eindbon: "Endbeleg",
    status: "Status",
    exclBtw: "Exkl. MwSt.",
    inclBtw: "Inkl. MwSt.",
    actie: "Aktion",
    soort: "Dokumenttyp",
    titel: "Titel",
    orderNietCompleetForecast: "Der Auftrag ist möglicherweise noch nicht vollständig genug, um das PDF zu erstellen. Sie wurden in unsere Prognose aufgenommen.",

    pagination: {
      previous: "Zurück",
      next: "Weiter",
      page: "Seite",
      of: "von",
    },

    login: {
      title: "Anmelden",
      email: "E-Mail",
      password: "Passwort",
      button: "Anmelden",
      forgotPassword: "Passwort vergessen?",
    },

    forgotPasswordPage: {
      title: "Passwort vergessen",
      intro:
        "Geben Sie unten Ihre E-Mail-Adresse ein. Wenn diese bei uns bekannt ist, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.",
      boxTitle: "Passwort vergessen",
      boxText:
        "Geben Sie die E-Mail-Adresse ein, mit der Sie sich im Portal anmelden. Wenn sie erkannt wird, erhalten Sie eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts.",
      button: "Reset-E-Mail senden",
      backToLogin: "Zurück zum Login",
    },

    resetPasswordPage: {
      title: "Neues Passwort festlegen",
      intro:
        "Geben Sie unten Ihr neues Passwort ein, um wieder Zugang zum Portal zu erhalten.",
      boxTitle: "Passwort zurücksetzen",
      boxText: "Geben Sie unten Ihr neues Passwort ein.",
      newPassword: "Neues Passwort",
      repeatPassword: "Passwort wiederholen",
      button: "Passwort speichern",
      invalidLink: "Der Reset-Link ist ungültig.",
      passwordsDontMatch: "Die Passwörter stimmen nicht überein.",
    },

    signupPage: {
      title: "Passwort festlegen",
      intro:
        "Geben Sie hier Ihre E-Mail-Adresse ein, mit der Sie sich im Kundenportal anmelden. Wenn diese erkannt wird, können Sie Ihr neues Passwort festlegen.",
      boxTitle: "Passwort festlegen",
      boxText:
        "Geben Sie die E-Mail-Adresse ein, mit der Sie sich im Portal anmelden. Wenn diese erkannt wird, können Sie Ihr neues Passwort festlegen.",
      passwordLabel: "Passwort für Kundenportal",
      checkEmail: "E-Mail prüfen",
      submit: "Festlegen",
    },
    evaluationStatusHeader: "Bewertungsstatus",
evaluationStatusPending: "Noch nicht gestartet",
evaluationStatusInProgress: "In Bearbeitung",
evaluationStatusCompleted: "Abgeschlossen",
evaluationStatusCancelled: "Storniert",
evaluationStatusUnknown: "Unbekannt",

evaluationActionStart: "Bewertung starten",
evaluationActionContinue: "Weiter ausfüllen",
evaluationActionCompleted: "Abgeschlossen",
evaluationActionCancelled: "Storniert",

evaluationsPageTitle: "Bewertungen",
evaluationSearchPlaceholder: "Nach Auftragsnummer, Kunde, Status oder Datum suchen...",
evaluationNoReleasedOrders: "Keine Aufträge verfügbar, für die eine Bewertung freigegeben wurde.",

evaluationLoadingTitle: "Bewertung wird geladen...",
evaluationUnavailableTitle: "Bewertung nicht verfügbar",
evaluationCompletedTitle: "Bewertung abgeschlossen",
evaluationCompletedText: "Diese Bewertung wurde bereits vollständig ausgefüllt und kann nicht mehr geändert werden.",
evaluationThankYouTitle: "Vielen Dank für Ihre Bewertung!",
evaluationThankYouText: "Ihr Feedback wurde erfolgreich gesendet.",

evaluationTitle: "Auftragsbewertung",
evaluationWelcomeTitle: "Willkommen zur Bewertung",
evaluationIntroOrderText: "Dies ist die Bewertung für",
evaluationIntroVarietyCountText: "Dieser Auftrag enthält",
evaluationVarieties: "Sorten",

evaluationStartButton: "Bewertung starten",
evaluationSavingButton: "Speichern...",
evaluationCompletingButton: "Wird abgeschlossen...",
evaluationCompleteButton: "Abschließen",

evaluationVariety: "Sorte",
evaluationVarietyInfoTitle: "Sorteninformationen",
evaluationVarietyLabel: "Sorte",
evaluationQuantityLabel: "Menge",

evaluationPlantExpectationsTitle: "Pflanzenerwartungen",
evaluationQuestionUniformity: "Pflanzenuniformität",
evaluationQuestionTrussDevelopment: "Traubenentwicklung",
evaluationTrussDevelopmentExplanationLabel: "Erläuterung zur Traubenentwicklung",
evaluationQuestionDaysToFlowering: "Anzahl Tage nach Lieferung bis zur Blüte",
evaluationQuestionLeavesBetweenTrusses: "Anzahl Blätter zwischen Traube 1 und 2",
evaluationQuestionOtherRemarks: "Sonstige Anmerkungen",

evaluationDiseasesPestsTitle: "Krankheiten / Schädlinge",
evaluationQuestionWhitefly: "Weiße Fliege",
evaluationQuestionCaterpillarTuta: "Raupe / Tuta",
evaluationQuestionThrips: "Thripse",
evaluationQuestionAphids: "Blattlaus",
evaluationQuestionOther: "Anders",
evaluationOtherDiseaseRemarkLabel: "Anmerkung zu, anders",
evaluationOtherDiseaseRemarkPlaceholder: "Beschreiben Sie, welche Krankheit oder welcher Schädling festgestellt wurde...",

evaluationGeneralDeliveryQuestionsTitle: "Allgemeine Fragen zur Lieferung",
evaluationVarietyQuestionsCompletedText: "Die sortenspezifischen Fragen wurden ausgefüllt.",
evaluationGeneralDeliveryQuestionsTextBeforeOrder: "Die folgenden Fragen beziehen sich auf die gesamte Lieferung von",
evaluationGeneralDeliveryQuestionsTextAfterOrder: "und gelten daher nicht pro Sorte, sondern für den Auftrag insgesamt.",

evaluationDeliveryTitle: "Lieferung",
evaluationQuestionStakePlacement: "Stäbe an der richtigen Stelle gesteckt",
evaluationQuestionElasticClipHeight: "Gummiband / Clip in der richtigen Höhe angebracht",
evaluationQuestionSortedCorrectly: "Gut sortiert",
evaluationQuestionTrolleysClean: "Trolleys bei Lieferung sauber",
evaluationQuestionDeliveredOnTime: "Lieferungen pünktlich",
evaluationQuestionTrialsDeviationsClear: "Versuche und Abweichungen deutlich gekennzeichnet",
evaluationQuestionPlantsDamaged: "Pflanzen beschädigt",

evaluationCommunicationTitle: "Kommunikation",
evaluationDepartmentHeader: "Abteilung",
evaluationDepartmentSales: "Vertrieb",
evaluationDepartmentCultivationManager: "Gartner",
evaluationDepartmentTransport: "Transportabteilung",

evaluationGeneralImpressionTitle: "Gesamteindruck",
evaluationGeneralImpressionLabel: "Gesamteindruck (1 bis 10)",
evaluationGeneralImpressionValidation: "Geben Sie eine Zahl zwischen 1 und 10 ein, um fortzufahren.",

evaluationOptionEqual: "Gleich",
evaluationOptionUnequal: "Ungleich",
evaluationOptionGood: "Gut",
evaluationOptionNotGood: "Nicht gut",
evaluationOptionModerate: "Mäßig",
evaluationOptionBad: "Schlecht",
evaluationOptionSufficient: "Ausreichend",
evaluationOptionInsufficient: "Unzureichend",

evaluationOptionBonken: "Verklumpte Traubenbildung",
evaluationOptionSplitTruss: "Gespaltene Traube",
evaluationOptionLeafOnTruss: "Blatt an der Traube",
evaluationOptionNoneNotApplicable: "Keine / nicht zutreffend",
evaluationOptionHeadless: "Kopflos",
evaluationOptionCurlyHead: "Krauskopf",
evaluationOptionShootCountDeviation: "Anzahl der Triebe weicht ab",
evaluationOptionPotTooDry: "Topf zu trocken",

evaluationSelectPlaceholder: "Bitte auswählen",

evaluationErrorAlreadyCompleted: "Diese Bewertung ist abgeschlossen und kann nicht mehr geändert werden.",
evaluationErrorSaveFailed: "Das Speichern der Bewertung ist fehlgeschlagen.",
evaluationErrorCompleteFailed: "Das Abschließen der Bewertung ist fehlgeschlagen.",
evaluationErrorNoVarieties: "Für diesen Auftrag wurden keine Sorten gefunden.",
evaluationErrorNotAllowed: "Für diesen Auftrag ist noch keine Bewertung freigegeben.",
evaluationErrorLoadFailed: "Die Bewertung konnte nicht geladen werden.",

order: "Auftrag",
pieces: "Stück",
yes: "Ja",
no: "Nein",
previous: "Zurück",
next: "Weiter",
of: "von",
page: "Seite",
notAvailable: "k. A.",
noOrdersAvailable: "Keine Aufträge verfügbar.",

  },

  fr: {
    administratie: "Administration",
    ordersGoedkeuren: "Approuver les commandes",
    teelt: "Culture",
    transport: "Transport",
    dossierTeelt: "Dossier de culture",
    dossierTransport: "Dossier de transport",
    klantgegevens: "Données client",
    orderinformatie: "Informations de commande",
    goedgekeurdeOrders: "Commandes approuvées",
    rollen: "Rôles",
    facturen: "Factures",
    factuur: "Facture",
    voorwaardenAccepteren: "Accepter les conditions",
    betreftOrder: "Concernant la commande :",
    algemeneVoorwaarden: "Conditions générales",
    voorwaardenAccepteren: "J’ai lu les conditions et je les accepte",
    goedkeuren: "Approuver",
    annuleren: "Annuler",
    vor: "VOR",
    grw: "GRW",
    globalGap: "GlobalGap",
    partijInformatie: "Informations du lot",
    algemeen: "Général",
    naam: "Nom",
    adres: "Adresse",
    postcode: "Code postal",
    plaats: "Ville",
    telefoon: "Téléphone",
    ordernummer: "Numéro de commande",
    detail: "Détails",
    download: "Télécharger",
    orderstatus: "Statut de la commande",
    verzendnaam: "Nom de livraison",
    orderdatum: "Date de commande",
    leverdatum: "Date de livraison",
    orderlijst: "Liste des commandes",
    plantPartijen: "Lots de plantes",
    teeltlijnen: "Lignes de culture",
    verzendAdres: "Adresse de livraison (si aucune adresse de livraison n'est disponible, elle est identique à l'adresse du débiteur)",
    contactpersonen: "Contacts",
    email: "E-mail",
    orderGoedkeuren: "Consulter et approuver la commande",
    gebruikersKlantenportaal: "Utilisateurs du portail client",
    verzendnr: "N° d'expédition",
    bedrijf: "Entreprise",
    laaddatumTijd: "Date et heure de chargement",
    leverdatumTijd: "Date et heure de livraison",
    ritnummer: "Numéro de transport",
    afgeleverd: "Livré",
    afleverdatum: "Date de livraison",
    tijd: "Heure",
    expediteurnaam: "Nom du transporteur",
    afleverbon: "Bon de livraison",
    plantenpaspoort: "Passeport phytosanitaire",
    transportMelden: "Signaler la livraison",
    zekerWeten: "Êtes-vous sûr ?",
    terug: "Annuler",
    uitloggen: "Se déconnecter",
    bevestigen: "Confirmer",
    transportBevestigen: "Confirmer la livraison",
    aantalFotos: "Nombre de photos",
    datum: "Date",
    zoekPlaceholderOrderinformatie: "Rechercher par numéro de commande, date...",
    zoekPlaceholderFacturen: "Rechercher par date, facture, commande...",
    zoekPlaceholderTransport: "Rechercher par transport, date...",
    omschrijving: "Description",
    vervaldatum: "Date d’échéance",
    eindbon: "Reçu final",
    status: "Statut",
    exclBtw: "HT",
    inclBtw: "TTC",
    actie: "Action",
    soort: "Type de document",
    titel: "Titre",
    orderNietCompleetForecast: "La commande n’est peut-être pas encore suffisamment complète pour générer le PDF. Vous êtes inclus dans notre prévision.",
    
    pagination: {
      previous: "Précédent",
      next: "Suivant",
      page: "Page",
      of: "sur",
    },

    login: {
      title: "Connexion",
      email: "E-mail",
      password: "Mot de passe",
      button: "Se connecter",
      forgotPassword: "Mot de passe oublié ?",
    },

    forgotPasswordPage: {
      title: "Mot de passe oublié",
      intro:
        "Saisissez votre adresse e-mail ci-dessous. Si elle est connue, vous recevrez un e-mail avec un lien pour réinitialiser votre mot de passe.",
      boxTitle: "Mot de passe oublié",
      boxText:
        "Saisissez l'adresse e-mail que vous utilisez pour vous connecter au portail. Si elle est reconnue, vous recevrez un e-mail avec les instructions de réinitialisation.",
      button: "Envoyer l’e-mail de réinitialisation",
      backToLogin: "Retour à la connexion",
    },

    resetPasswordPage: {
      title: "Définir un nouveau mot de passe",
      intro:
        "Saisissez votre nouveau mot de passe ci-dessous pour retrouver l'accès au portail.",
      boxTitle: "Réinitialiser le mot de passe",
      boxText: "Saisissez votre nouveau mot de passe ci-dessous.",
      newPassword: "Nouveau mot de passe",
      repeatPassword: "Répéter le mot de passe",
      button: "Enregistrer le mot de passe",
      invalidLink: "Le lien de réinitialisation n’est pas valide.",
      passwordsDontMatch: "Les mots de passe ne correspondent pas.",
    },

    signupPage: {
      title: "Définir le mot de passe",
      intro:
        "Saisissez l’adresse e-mail que vous utilisez pour vous connecter au portail client. Si elle est reconnue, vous pouvez définir votre nouveau mot de passe.",
      boxTitle: "Définir le mot de passe",
      boxText:
        "Saisissez l’adresse e-mail que vous utilisez pour vous connecter au portail. Si elle est reconnue, vous pouvez définir votre nouveau mot de passe.",
      passwordLabel: "Mot de passe du portail client",
      checkEmail: "Vérifier l’e-mail",
      submit: "Définir",
    },
  }
};

export default translations;